import * as _4 from 'lodash4';
class DevReqLegendController {
  private iconTheme: string;
  iconId = 'required-developmental-course-info-' + _4.uniqueId();
}
angular.module('capability-ng-academic-planner').component('previewTermPlanDevReqLegend', {
  controller: DevReqLegendController,
  bindings: {
    iconTheme: '@'
  },
  templateUrl:
    'capability-ng-academic-planner/src/preferences/components/preview_plan/components/preview_term_plan_legends/preview_term_plan_dev_req_legend/preview_term_plan_dev_req_legend.html'
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/preview_plan/components/preview_term_plan_legends/preview_term_plan_dev_req_legend/preview_term_plan_dev_req_legend.ts